import {Text} from '../../1elements'


const SelectServiceTypeInstruction = () => {
    return(
        <Text>
          Please select a service type from the side menu
            {/*by clicking <AddCircleOutlineIcon/> button on the side menu*/}
        </Text>
    )
}

export default SelectServiceTypeInstruction